import { ReactElement, ReactNode, useCallback } from 'react';
import { NavLink } from 'react-router';

// Hooks.
import { useClickEvent } from 'hooks';

interface ITabProps {
  children?: ReactNode;
  end?: boolean;
  link: string;
  title: string;
}

export const Tab = (props: ITabProps): ReactElement => {
  const { children, title, link, end } = props;

  const fireNavigationEvent = useClickEvent({ Event: 'Navigation', EventCategory: 'Navigation' });

  const handleClick = useCallback(
    (e) => {
      fireNavigationEvent({ EventAction: e.target.textContent, EventLabel: e.currentTarget.getAttribute('href') });
    },
    [fireNavigationEvent],
  );

  return (
    <NavLink to={link} end={end} className={({ isActive }) => (isActive ? 'active' : '')} onClick={handleClick}>
      {children}
      <span>{title}</span>
    </NavLink>
  );
};
